<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Patient</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" (keyup.enter)="SaveUser()">
  @if(patient != null)
  {
  <div class="row">
    <div class="col-3"><GeschlechtsAuswahl  [Geschlecht]="patient.geschlecht ?? 0" (GeschlechtChange)="patient.geschlecht = $event"></GeschlechtsAuswahl></div>
    <div class="col-3">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Anrede" [(ngModel)]="patient.anrede">
        <label for="Anrede">Anrede</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Vorname" [(ngModel)]="patient.vorname">
        <label for="Vorname">Vorname</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Nachname" [(ngModel)]="patient.nachname">
        <label for="Nachname">Nachname</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="VersicherungsNr" [EKVNummerMask]="VNummerType" [(ngModel)]="patient.versicherungsnummer" [disabled]="!VNummerEnabeld" [readonly]="!VNummerEnabeld"  >
        <label for="VersicherungsNr">Versicherungs Nr</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-floating">
        <select class="form-select"
                id="Gkv"
                [(ngModel)]="patient.gesetzlichVersichert">
          <option *ngFor="let item of GKVPKV" [ngValue]="item.id">
            {{ item.name }}
          </option>
        </select>

        <label for="Gkv">Versicherungsart</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-floating">
        <select class="form-select"
                id="Beihilfe"
                [(ngModel)]="patient.beihilfe">

          <option *ngFor="let item of Beihilfe" [ngValue]="item.id">
            {{ item.name }}
          </option>
        </select>

        <label for="Beihilfe">Beihilfe</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="Pflegegrad" [(ngModel)]="patient.pflegegrad">
        <label for="Pflegegrad">Pflegegrad</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <Date-Select [(Date)]="patient.geburtstag" LabelText="Geburtstag"></Date-Select>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Telefon" Phonenumber [(ngModel)]="patient.phone">
        <label for="Telefon">Telefon</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Telefon2" Phonenumber [(ngModel)]="patient.phone2">
        <label for="Telefon2">Telefon (Alternativ)</label>
      </div>
    </div>
    <div class="col-3">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Mail" [(ngModel)]="patient.email">
        <label for="Mail">Mail</label>
      </div>
    </div>
  </div>
<div class="row" *Authorize="Rights.CreateCompanyEntrys">
  <div class="col-3">
    <div class="form-check mb-3">
      <input name="isCompany" id="isCompany" class="form-check-input" type="checkbox"
             [checked]="patient.isCompany"
             (change)="patient.isCompany = !patient.isCompany" />
      <label for="isCompany" class="form-check-label">Ist eine Firma (Test Geräte)</label>
    </div>
  </div>
</div>
  <Address [(address)]="adresse"></Address>
  <div class="row">
    <div class="col">
      <KassenSelect [(selection)]="patient.kasse"></KassenSelect>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="IBAN" [(ngModel)]="patient.iban">
        <label for="IBAN">IBAN</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Bank" [(ngModel)]="patient.bank">
        <label for="Bank">Bank</label>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <textarea type="text" class="form-control" id="Info" [(ngModel)]="patient.info"></textarea>
        <label for="Info">Info</label>
      </div>
    </div>
  </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('')">Abbrechen</button>
  <button type="button" class="btn btn-success" (click)="SaveUser()" *IsSpezialUser>Speichern</button>
</div>
